import { render, staticRenderFns } from "./report.table.vue?vue&type=template&id=2088ff74"
import script from "./report.table.vue?vue&type=script&lang=js"
export * from "./report.table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports